var React = require('react');

function NestArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.3421 7.78925L3.33499 26.7964L0.212402 23.6738L19.2173 4.66667H2.46711V0.25H26.7588V24.5417H22.3421V7.78925Z","fill":"#EBE7E4"}));
}

NestArrow.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = NestArrow;

NestArrow.default = NestArrow;
